import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { showToastWithErrorMsg } from './showToastWithErrorMsg';

export type OWAHandledNetworkError = Error & {
    networkError?: boolean;
    diagnosticInfo?: string;
};

/**
 * when lazy load of the action fails
 * Note: e?.diagnosticInfo.includes('Loading chunk') this error comes only for LazyModule
 * If you want to show network error even for service network errors
 * then remove this condition and same code will show toast for both
 */
export function networkFailureHandler(e: OWAHandledNetworkError) {
    if (e?.networkError === true && e?.diagnosticInfo?.includes('Loading chunk')) {
        const owaMiniCommonStrings = getOwaMiniCommonStrings();
        const { networkErrorToastTitle } = owaMiniCommonStrings;
        return showToastWithErrorMsg(networkErrorToastTitle);
    } else {
        return Promise.reject(e);
    }
}
